module.exports = __webpack_public_path__ + "static/media/glass2.0f9d85fd.jpg";